module.exports = __webpack_public_path__ + "img/20191025171746360截图20191025162355132.4f0a1c5a.jpg";